module.exports = __webpack_public_path__ + "static/media/MoveRight.svg";